module.exports = __webpack_public_path__ + "static/media/video4.a133cb9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video4.mp4
// module id = yR5/
// module chunks = 1